/* -------------------------------------------------------------------------- */
/*  Model Data — aggregation & exports                                        */
/*  UX-43: Model Page Template                                                */
/* -------------------------------------------------------------------------- */

import { type ModelData } from './model-data-types';
import { luxuryModelsA } from './model-data-luxury-a';
import { luxuryModelsB } from './model-data-luxury-b';
import { luxuryModelsC } from './model-data-luxury-c';
import { domesticModelsA } from './model-data-domestic-a';
import { domesticModelsB } from './model-data-domestic-b';
import { importModelsA } from './model-data-import-a';
import { importModelsB } from './model-data-import-b';
import { importModelsC } from './model-data-import-c';
import { electricModels } from './model-data-electric';

export type { ModelData } from './model-data-types';

export const allModels: ModelData[] = [
  ...luxuryModelsA,
  ...luxuryModelsB,
  ...luxuryModelsC,
  ...domesticModelsA,
  ...domesticModelsB,
  ...importModelsA,
  ...importModelsB,
  ...importModelsC,
  ...electricModels,
];

export const modelMap = new Map(allModels.map((m) => [`${m.brandSlug}/${m.slug}`, m]));

export function getModelBySlug(brandSlug: string, modelSlug: string): ModelData | undefined {
  return modelMap.get(`${brandSlug}/${modelSlug}`);
}

export function getModelsByBrand(brandSlug: string): ModelData[] {
  return allModels.filter((m) => m.brandSlug === brandSlug);
}

export function getModelsByBodyType(bodyType: ModelData['bodyType']): ModelData[] {
  return allModels.filter((m) => m.bodyType === bodyType);
}
